export enum ChannelTypeEnum {
  SMS = 1,
  WHATSAPP = 2,
  INTERNAL = 3,
}

export enum MessageStatusEnum {
  SENDING = -1,
  SENT = 1,
  DELIVERED = 2,
  OPENED = -1,
  FAILED = 4,
  SCHEDULED = 0,
}

export enum GroupTypesEnum {
  IMMEDIATE_ACTION = 'Immediate Action',
  LATEST_MESSAGES = 'Latest Messages',
}

export enum ConversationFilterEnum {
  ALL_MESSAGES = 'All Messages',
  MY_MESSAGES = 'My Messages',
  UNREAD = 'Unread',
  UNASSIGNED = 'Unassigned',
  ARCHIVED = 'Archived',
}

export enum ParticipantTypeEnum {
  PHONE_NUMBER = 'phone_number',
  CONTACT = 'contact',
  USER = 'user',
}
